// extracted by mini-css-extract-plugin
module.exports = {"text-modal":"network-text_text-modal__1s109"};